module.exports = __webpack_public_path__ + "img/nogo-singlepackage-min.d4b2b793.jpg";